import * as React from 'react'
import ReactSkeleton, { SkeletonProps } from 'react-loading-skeleton'

const Skeleton: React.FunctionComponent<SkeletonProps> = (props) => <ReactSkeleton {...props} />

export default Skeleton
